import { WEIGHTS } from '../../Text';
export const getTextWeight = (isSubheader, newColorsBranding) => {
    if (!newColorsBranding) {
        return WEIGHTS.thin;
    }
    return isSubheader ? WEIGHTS.normal : WEIGHTS.bold;
};
//# sourceMappingURL=getTextWeight.js.map